import React from "react";
import { Drawer, Position } from "@blueprintjs/core";

import Sidebar, { IProps as ISidebarProps } from "../Sidebar";

interface IProps extends ISidebarProps {
  isOpen: boolean;
  closeDrawer: () => any;
}

export default (props: IProps) => {
  const { isOpen, closeDrawer, ...rest } = props;
  return (
    <Drawer
      isOpen={isOpen}
      size="max-content"
      onClose={closeDrawer}
      position={Position.LEFT}
    >
      <Sidebar {...rest} />
    </Drawer>
  );
};
